import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { useLoyaltyPageContext } from '../../context';
import { CampaignDetails } from './campaigns';
import { useIsSmallScreen } from '../../hooks';

const CashbackSection: React.FC = () => {
  const {
    isMobilePreview,
    cashbackProgram: {
      liveCampaigns,
    },
  } = useLoyaltyPageContext();

  const isMobile = useIsSmallScreen();

  return (
    <Box bgcolor="#fff">
      <Container maxWidth="lg" disableGutters={!isMobile && !isMobilePreview} sx={{ py: { xs: 3, sm: 5 }, px: 2 }}>
        <Typography variant="h1" textAlign="center" mb={4}>
          <Trans
            i18nKey="loyaltyPage.campaigns.title"
            defaults="Participate in Live Campaigns"
          />
        </Typography>
        <Grid container spacing={5} alignItems="stretch" wrap={isMobile || isMobilePreview ? 'wrap' : 'nowrap'}>
          {liveCampaigns.map((campaign) => (
            <Grid>
              <CampaignDetails campaignData={campaign} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CashbackSection;
